module.exports = __webpack_public_path__ + "img/icon-cart.346c7696.svg";